// extracted by mini-css-extract-plugin
module.exports = {"SpotQuoteButton":"SpotQuoteButton_SpotQuoteButton__3pNrI"};